module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-32.986898be.png";